import React from 'react'
import { useTranslation } from 'react-i18next';
import { rightArrow, subMenuHome, subMenuPartners, subMenuProjects, whyUs } from '../../../assets/images';


  const newsItems = [
    {
      id: 1,
      imgSrc: subMenuHome,
      title: 'İsitmə',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    },
    {
      id: 2,
      imgSrc: subMenuPartners,
      title: 'Ventilyasiya',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    },
    {
      id: 3,
      imgSrc: subMenuProjects,
      title: 'Soyutma, kondisionerləşdirmə',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    },
    {
        id: 4,
        imgSrc: subMenuHome,
        title: 'Santexnika',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 5,
        imgSrc: subMenuPartners,
        title: 'Yanğınsöndürmə',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 6,
        imgSrc: subMenuProjects,
        title: 'Elektrik sistemləri',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 7,
        imgSrc: subMenuHome,
        title: 'Aşağı cərəyan',
         description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 8,
        imgSrc: subMenuPartners,
        title: 'Avtomatlaşdırma sistemləri',
         description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 9,
        imgSrc: subMenuProjects,
        title: 'Kanal sexi',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
  ];

const CareersStartersItems = () => {


      const { t } = useTranslation();

  return (
    <div className='pt-[88px] md:pt-[104px] bg-[#FBFBFB]'>
        <div className='max-w-containerSm md:max-w-container mx-auto gap-5'>
        <div className=' text-[#1C1C1C]'>
    <p className='mt-6'>Biz tələbələr və məzunlar üçün xüsusi imkanlar təqdim edirik, onların peşəkar inkişafını dəstəkləyirik və gələcək liderlər kimi böyümələrinə şərait yaradırıq.    </p>
    <p className='mt-6'>Universitetdə əldə olunan nəzəri bilikləri praktiki təcrübə ilə birləşdiririk. Təcrübə proqramlarımız vasitəsilə biz tələbələrə və məzunlara real layihələr üzərində işləmək və tikinti mütəxəssisləri ilə əməkdaşlıq etmək imkanını təklif edirik.    </p>
    <p className='mt-6'>Universitetlərlə əməkdaşlıq ilə tələbələrin və məzunların işlə təmin olunmasına dəstək göstəririk. CV hazırlanması, müsahibə üsulları və karyera planlaması üzrə seminarlar təşkil edirik. İş və təcrübə imkanlarımızı karyera sərgilərində iştirak edərək nümayiş etdiririk.    </p>
    <p className='mt-6'>Akond məzunların istedad və potensialını qiymətləndirir, onların davamlı inkişafı üçün təcrübə və mentorluq proqramlarını təqdim edir.</p>
    
        </div>


    </div>
    </div>
  )
}

export default CareersStartersItems